import { HierarchyContextProps, IHierarchyActionUpdateHierarchyComment } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Adds or replaces a hierarchy comment in the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The update-hierarchy-comment action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_updateHierarchyComment = (
  state: HierarchyContextProps,
  action: IHierarchyActionUpdateHierarchyComment,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  return hcr_updateChangedFlag(
    {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        comments: [
          ...state.hierarchy.comments.filter((c) => c.id !== action.comment.id),
          action.comment,
        ],
      },
    },
    action,
  );
};
